import React from "react";

export default function CardLink(props) {
  if (!props.src) {
    return null;
  }

  return (
    <div style={{ marginRight: "0px", overflow: "hidden" }}>
      <button
        style={{
          backgroundColor: "#7498b0",
          color: "white",
          border: "none", // "1px solid #fff",
          padding: "10px 24px",
          cursor: "pointer",
          float: "right",
        }}
        onClick={(e) => {
          e.preventDefault();
          console.log("button clicked");
          window.open(props.src, "_blank");
          // window.location.href = "http://google.com";
        }}
      >
        Explore the map
      </button>
    </div>
  );
}
